import { useNavigate } from "react-router-dom";

import { Modal } from "antd";

import styles from "@/components/common/SuccessModal/success.module.css";
import { IMAGES, ROUTES_URL } from "@/constant";

interface SuccessModalProps {
  open: boolean;
  title: string;
  subTitle?: string;
  isBackToLogin?: boolean;
  onClose?: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  open,
  onClose,
  title,
  subTitle,
  isBackToLogin,
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      closable={Boolean(onClose)}
      footer={null}
      centered
      width={"577px"}
      className={styles.modalBorderRedious}
    >
      <div className={styles.successWrapper}>
        <img src={IMAGES.SUCCESS_ICON} className={styles.successIcon} alt="Success" />

        <div className={styles.successTitle}>{title}</div>

        {subTitle ? <p className={styles.successDescription}>{subTitle}</p> : <></>}

        {isBackToLogin ? (
          <div className={styles.footer} onClick={() => navigate(ROUTES_URL.LOGIN)}>
            <img src={IMAGES.LOGIN_RIGHT_ARROW} alt="back to login" /> Back to Login
          </div>
        ) : null}
      </div>
    </Modal>
  );
};

export default SuccessModal;
